// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare

import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route} from 'react-router';
import { Auction, NotAuthenticated } from './features';
import { useSelector } from 'react-redux';
import { useAppDispatch } from './store';
import {
  AuthenticateUserAction,
  FetchAuctionDataOnlyWithDateAction,
  FetchBookAction,
  FetchFiltersAndAuctionCalendarAction,
  FetchProfileAction,
  IAllocationResultUpdate,
  IApplicationState,
  IAuctionCalendarUpdateRequest,
  ICorridorStatusRequest,
} from './store';
import { FeatureHeadings, IAuction } from './services';
import LoadingPage from './components/LoadingPage/LoadingPage';
import {HubConnectionBuilder} from '@microsoft/signalr';
import { getAuctionBaseUrl } from './core';
import { getStratosAccessToken } from './core/clients/HttpClients';
import Bids from './features/Bid/Bids';
import { toast } from 'react-toastify';
import { format } from 'react-string-format';
import ExchangeConfig from './features/ConfigurationManagement/ExchangeConfig';
import EtrmConfig from './features/ConfigurationManagement/EtrmConfig';
import NavMenu from './NavMenu';
import Result from './features/Result/Result';
import Results from './features/Results/Results';
import { ProfilePage } from './features/Profile/Profile';
import { AccessDeniedPage } from './features/AccessDenied/AccessDenied';
import { ItaEnvironment } from './store/Profile/enum/Ita-environment';
import { ItaProdPolicy } from './store/Profile/enum/Ita-prod-policy';
import { ItaNonProdPolicy } from './store/Profile/enum/Ita-nonprod-policy';
import { OverlayStyle } from './App.routing.styled';
import { PostAuditAction } from './store/Audit/ActionCreator';
import AuctionCalendar from './features/AuctionCalendar/AuctionCalendar';
import Returns from './features/Returns/Returns';
import { SignInCallback, SilentRenew, AuthenticationService } from './Authentication';

export interface IAppRouting {}

// Track if login redirect has been initiated to prevent infinite loops
let loginRedirectInProgress = false;

const AppRouting: React.FC<IAppRouting> = () => {
  const showBidPanel = useSelector((state: IApplicationState) => state.bidPanel.showBidPanel);
  const showResultPanel = useSelector((state: IApplicationState) => state.result.showResultPanel);
  const showResultsPanel = useSelector((state: IApplicationState) => state.results.showResultsPanel);
  const showReturnsPanel = useSelector((state: IApplicationState) => state.returns.showReturnsPanel);

  const [zIndexValue, setZIndexValue] = useState(0);
  const [opacity, setOpacity] = useState(1);
  
  const dispatch = useAppDispatch();
  const auth = useSelector((state: IApplicationState) => state.auth);  
  const profile = useSelector((state: IApplicationState) => state.profile.profile);
  const profileLoading = useSelector((state: IApplicationState) => state.profile.loading);

  useEffect(() => {
    const reload = 290; //290 seconds, just under 5 mins
    const autoRefresh = setInterval(() => {
        dispatch(FetchBookAction()); //smallest call to the API to keep the cookie alive
    }, reload * 1000)

   return () => {// Clear previous timeout
      clearInterval(autoRefresh)
   }
}, [dispatch]);

  useEffect(() => {
    dispatch(AuthenticateUserAction());
  }, [dispatch]);

  // Dispatch FetchProfileAction only after authentication is confirmed.
  // If dispatched unconditionally on mount, the profile API call fires before
  // the user has a valid token, returns 401, and sets profile.loading=false —
  // causing the profileLoading guard to be bypassed after the IDP callback.
  useEffect(() => {
    if (auth.login) {
      dispatch(FetchProfileAction());
    }
  }, [auth.login, dispatch]);

  useEffect(() => {
    // Wait for a real session before connecting: starting negotiation before auth
    // completes fails permanently (withAutomaticReconnect only covers drops of an
    // already-established connection, not a failed initial start()).
    if (!auth.login) {
      return;
    }

    const newConnection = new HubConnectionBuilder()
      .withUrl(`${getAuctionBaseUrl()}hub/corridor`,{ accessTokenFactory:()=>getStratosAccessToken().then<string>()})
      // .withUrl(`${getAuctionBaseUrl()}hub/corridor`)
      .withAutomaticReconnect()
      .configureLogging(2)
      .build();
    
    // Start - Create SignalR Connection via AuctionAPI --> CorridorHub
    newConnection
      .start()
      .then(() => console.log(' Signal R Auction hub Connection Started!'))
      .catch((err) => {
        console.log('Signal R Auction Hub connection Error' + err);
      });
    // End - Create SignalR Connection via AuctionAPI --> CorridorHub

    // Start - SignalR Message to Get Notified on Auction Data Update
    newConnection.on('AuctionCorridorStatusChanged', (data: ICorridorStatusRequest[]) => {
      console.log('Auction Corridor Status Triggered : ' + new Date().toString());
      const auctionCorridor = data.map(x => {
        return { corridor : x.corridorCode} as IAuction
      }) 
      dispatch(FetchAuctionDataOnlyWithDateAction(auctionCorridor));
    });
    // End - SignalR Message to Get Notified on Auction Data Update

    // Start - SignalR Message to Get Notified on Auction Calendar Update
    newConnection.on('AuctionCalendarUpdated', (data: IAuctionCalendarUpdateRequest) => {
      console.log('Auction Calendar Update is Triggered : ' + new Date().toString());
      if (data.isCalendarUpdated)
       dispatch(FetchFiltersAndAuctionCalendarAction());
    });
    // End - SignalR Message to Get Notified on Auction Calendar Update

    // Start - SignalR Message to Get Notified on Allocation Result Update
    newConnection.on('AllocationResultUpdate', (data: IAllocationResultUpdate[]) => 
    {
        //debugger;
        console.log('Allocation Result Update Triggered : ' + new Date().toString());
        if(data.length > 0)
        {
          // Start - Loop Through All Allocation Result
          for (const bidStatus of data) 
          {
              if(bidStatus.quantity > 0)
              { 
                  var message = "";
                  var isNonTermAuction = (bidStatus.auctionId.indexOf("DAILY") > 0 || bidStatus.auctionId.indexOf("I-ID") > 0
                  || bidStatus.auctionId.indexOf("I-HOURLY") > 0);
                  
                  if(bidStatus.zkey != null && bidStatus.zkey != "")
                  {
                      if (isNonTermAuction)
                        message = format('Bid Won💥 for {0} : Vol = {1}, Zkey={2}', bidStatus.auctionId, bidStatus.quantity, bidStatus.zkey);
                      else 
                        message = format('Bid Won💥 for {0} : Vol = {1}, Price = {2}, Zkey={3}', bidStatus.auctionId, bidStatus.quantity, bidStatus.price, bidStatus.zkey); 
                      toast.success(message, {autoClose:false, draggable:true});
                  }
                  else
                  {
                      if(bidStatus.status === 'Received_Aligne_Response' || bidStatus.status === 'Processing')
                      {
                          if (isNonTermAuction)
                            message = format('Bid Won but Aligne Push Unconfirmed for {0} : Vol = {1}, Zkey=null', bidStatus.auctionId, bidStatus.quantity);
                          else 
                            message = format('Bid Won but Aligne Push Unconfirmed for {0} : Vol = {1}, Price = {2}, Zkey=null', bidStatus.auctionId, bidStatus.quantity, bidStatus.price);
                          toast.warn(message, {autoClose:false, draggable:true});
                      }
                      else
                      {
                          if (isNonTermAuction)
                            message = format('Bid Won but Aligne Errored for {0} : Vol = {1}, Zkey=null', bidStatus.auctionId, bidStatus.quantity);
                          else 
                            message = format('Bid Won but Aligne Errored for {0} : Vol = {1}, Price = {2}, Zkey=null', bidStatus.auctionId, bidStatus.quantity, bidStatus.price);
                            
                          toast.error(message, {autoClose:false,draggable:true});
                      }
                  }
              }
              else
              {
                  toast.info(format('No Bid Won for {0}', bidStatus.auctionId), {autoClose:false,draggable:true});
              }
          }
          // End - Loop Through All Allocation Result
        }
    });
    // End - SignalR Message to Get Notified on Allocation Result Update 

    return () => {
      newConnection.stop();
    };
  }, [auth.login]);
  
  useEffect(() => {
    if (showBidPanel || showResultPanel || showResultsPanel || showReturnsPanel) {
      setOpacity(0.5);
      setZIndexValue(-1);
    } else {
      setOpacity(1);
      setZIndexValue(0);
    }
  }, [showBidPanel, showResultPanel, showResultsPanel, showReturnsPanel]); 

  const isAuthorizationLevelDenied = () => {
    let accessDenied = false;
    if (profile?.environment == ItaEnvironment.PRD) {
      if (profile?.itaProdPolicy == ItaProdPolicy.NoAccess) {
        accessDenied = true;
      }
    }
    else {
      if (profile?.itaNonProdPolicy == ItaNonProdPolicy.NoAccessNonProd) {
        accessDenied = true;
      }
    }   
    return accessDenied;
  }

  // OIDC callback routes - must be accessible before authentication check
  const currentPath = window.location.pathname;
  if (currentPath === '/signin-callback') {
    return <SignInCallback returnUrl="/" />;
  }
  if (currentPath === '/silent-renew') {
    return <SilentRenew />;
  }
 
  if (auth.loading) {
    return (
      <LoadingPage message='Please wait while you are being authenticated. Thank you for your patience.'></LoadingPage>
    );
  } else if (!auth.loading && !auth.login) { 
    // No authenticated user - redirect to IDP login (only once)
    if (!loginRedirectInProgress) {
      loginRedirectInProgress = true;
      console.log('[App.routing] Not authenticated, redirecting to login...');
      AuthenticationService.Instance.login(window.location.pathname + window.location.search + window.location.hash);
    }
    return (
      <LoadingPage message='Redirecting to login...'></LoadingPage>
    );
  } else if (profileLoading) {
    // Wait for profile to load before checking authorization level.
    // Without this, isAuthorizationLevelDenied() evaluates against an empty
    // profile ({}) and always returns false, letting unauthorized users through.
    return (
      <LoadingPage message='Please wait while your profile is being loaded.'></LoadingPage>
    );
  } else if (isAuthorizationLevelDenied()) {
    if (!authorizationAudited()) {
    dispatch(PostAuditAction({
      action: 'Authorization',
      infoMessage: 'Failed',
      createdOn: new Date()
    }))}
    return <AccessDeniedPage></AccessDeniedPage>;
  } else {
    if (!authenticationAudited()) {
      dispatch(PostAuditAction({
        action: 'Authentication',
        infoMessage: 'Success',
        createdOn: new Date()
      }))
    };
    
  // Render the app content within the LaunchDarkly provider if initialized
  const renderContent = () => (
    <>
      {showBidPanel && <Bids />}
      {showResultPanel && <Result />}
      {showResultsPanel && <Results />}
      {showReturnsPanel && <Returns />}
      <OverlayStyle opacity={opacity} zIndexValue={zIndexValue}>
        {
          <NavMenu />
        }
        <Routes>
          <Route path='/' element={<Auction />} />
          <Route path={`/${FeatureHeadings.Auctions.toLowerCase()}`} element={<Auction />} />
          <Route
          path={`/${FeatureHeadings.ExchangeConfig.replace(/ /g, "").toLowerCase()}`}
          element={<ExchangeConfig />}
          />
          <Route
            path={`/${FeatureHeadings.EtrmConfig.replace(/ /g, "").toLowerCase()}`}
            element={<EtrmConfig />}
          />
          <Route
            path={`/${FeatureHeadings.Profile.toLowerCase()}`}
            element={<ProfilePage />}
          />         
          <Route path={`/${FeatureHeadings.AuctionCalendar.replace(/ /g, "").toLowerCase()}`} element={<AuctionCalendar />} />
          <Route
            path={`/${FeatureHeadings.NotAuthenticated.toLowerCase()}`}
            element={<NotAuthenticated />}
          />
          <Route
            path={`/${FeatureHeadings.AccessDenied.toLowerCase()}`}
            element={<AccessDeniedPage />}
          />
        </Routes>
      </OverlayStyle> 
    </>
  );

  return renderContent();
  }
};

export const authenticationAudited = () => {
  let alreadyAuthenticated = window.sessionStorage.getItem('already-authenticated') === 'true';
  if (!alreadyAuthenticated) { 
    window.sessionStorage.setItem('already-authenticated', 'true');
  }
  return alreadyAuthenticated;
};

export const authorizationAudited = () => {
  let alreadyAuthorized = window.sessionStorage.getItem('already-authorized') === 'true';  
  if (!alreadyAuthorized) {
    window.sessionStorage.setItem('already-authorized', 'true');
  }
  return alreadyAuthorized;
};

export default AppRouting;